// extracted by mini-css-extract-plugin
module.exports = {"Tabs":"Tabs_Tabs__2ZSvt","Tab":"Tabs_Tab__2iXXm","Active":"Tabs_Active__2-EnT"};